/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIV1AuthEmailRequestTestGetLatestTokenCreate200Response
 */
export interface APIV1AuthEmailRequestTestGetLatestTokenCreate200Response {
    /**
     * 
     * @type {string}
     * @memberof APIV1AuthEmailRequestTestGetLatestTokenCreate200Response
     */
    token?: string;
}

/**
 * Check if a given object implements the APIV1AuthEmailRequestTestGetLatestTokenCreate200Response interface.
 */
export function instanceOfAPIV1AuthEmailRequestTestGetLatestTokenCreate200Response(value: object): value is APIV1AuthEmailRequestTestGetLatestTokenCreate200Response {
    return true;
}

export function APIV1AuthEmailRequestTestGetLatestTokenCreate200ResponseFromJSON(json: any): APIV1AuthEmailRequestTestGetLatestTokenCreate200Response {
    return APIV1AuthEmailRequestTestGetLatestTokenCreate200ResponseFromJSONTyped(json, false);
}

export function APIV1AuthEmailRequestTestGetLatestTokenCreate200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIV1AuthEmailRequestTestGetLatestTokenCreate200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : json['token'],
    };
}

export function APIV1AuthEmailRequestTestGetLatestTokenCreate200ResponseToJSON(value?: APIV1AuthEmailRequestTestGetLatestTokenCreate200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
    };
}

